import React, { useState } from 'react'
import { axios } from 'api'
import {
  ProgramStart,
  StartMainContainer
} from 'components_v1/programs/ProgramComponents'
import uuidv4 from 'uuid/v4'
import { Spinner } from 'ui/bend'
import { useAlert } from 'hooks'

const MarkComplete = ({ plan_entry_id }) => {
  const [status, setStatus] = useState('unmarked')
  const setAlert = useAlert()
  const markComplete = async () => {
    if (status !== 'unmarked') return
    setStatus('loading')
    try {
      const client_uuid = uuidv4()
      const postBody = {
        plan_entry_id: Number(plan_entry_id),
        progress_seconds: 0,
        occurred_at: new Date().toUTCString(),
        client_uuid
      }

      const res = await axios.post(
        `video_events/time_update/web?version=1`,
        postBody,
        {
          params: {
            version: '1'
          }
        }
      )
      window.dataLayer ||= []
      if (res?.data?.ga4Event) {
        setAlert(
          {
            message: 'Class marked as complete.'
          },
          { autoClose: 3000 }
        )
        setStatus('marked')
      }
      if (res.data?.programEvents?.length > 0) {
        window.dataLayer.push(...res.data?.programEvents)
      }
    } catch (e) {
      setStatus('unmarked')
      console.error(e)
    }
  }

  if (status === 'marked') return null

  return (
    <StartMainContainer>
      <ProgramStart id='program-start-button' onClick={markComplete}>
        {status === 'unmarked' ? 'Mark as complete' : <Spinner />}
      </ProgramStart>
    </StartMainContainer>
  )
}

export default MarkComplete
